import '../styles/MassUploadStyle.css';
import '../styles/BatuInfoStyle.css';
import { ChangeEvent, useState, useRef } from 'react';
import { useActions, useTypedSelector } from '../../hooks';
import Papa from 'papaparse';
import { MdOutlineFileUpload } from 'react-icons/md';
import { IoMdClose } from 'react-icons/io';
import { RPURequestItem } from '../../models/types';

const MAX_RPU_COUNT = 500;

const formatRpu = (rpu: string): string => {
  return rpu.replace(/[\s']/g, '');
};

const isValidRpu = (rpu: string): boolean => {
  return !(
    rpu === '' ||
    isNaN(parseInt(rpu)) ||
    !/^\d+$/.test(rpu) ||
    rpu.includes('000000')
  );
};

const MassUpload: React.FC = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const massUploadFile = useTypedSelector(({ bills }) => {
    return bills.massUploadFile;
  });
  const fileRef = useRef<HTMLInputElement>(null);
  const { updateMassUploadFile, updateMassUploadRpuList } = useActions();
  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.currentTarget.files;
    console.log(files);
    setErrorMessage('');
    if (!files) {
      setErrorMessage('Por favor carga un archivo');
      return;
    }
    if (files && files?.length > 1) {
      setErrorMessage('Por favor carga un solo archivo');
      return;
    }
    let csvFile = files[0];
    if (csvFile.type !== 'text/csv') {
      setErrorMessage('Por favor carga un archivo de tipo .csv');
      return;
    }
    // Passing file data (event.target.files[0]) to parse using Papa.parse
    Papa.parse(csvFile, {
      header: true,
      skipEmptyLines: true,
      complete: function (results) {
        console.log('results:', results);

        let headerArray: any[] = [];
        const valuesArray: any[] = [];
        // Iterating data to get column name and their values
        results.data.forEach((d: any, index: number) => {
          const keys = Object.keys(d).map((key) => key.toLowerCase());
          if (index === 0) {
            headerArray = keys;
          }
          valuesArray.push(Object.values(d));
        });
        // Filtered Column Names
        if (!headerArray.includes('rpu')) {
          setErrorMessage("El archivo debe contener un campo 'rpu'.");
          return;
        }
        let indexRpu = headerArray.indexOf('rpu');
        let indexServiceName = headerArray.indexOf('servicename');
        let indexLatestTotal = headerArray.indexOf('total');
        const rpuValues: RPURequestItem[] = valuesArray.map((row) => {
          const value = {
            rpu: formatRpu(row[indexRpu]),
            serviceName: row[indexServiceName],
            latestTotal: row[indexLatestTotal],
          };
          return value;
        });
        console.log(rpuValues);
        if (
          rpuValues.some((value) => {
            if (!isValidRpu(value.rpu)) {
              setErrorMessage(`${value.rpu} no es un valor válido`);
              return true;
            }
            return false;
          })
        ) {
          return;
        }
        if (rpuValues.length > MAX_RPU_COUNT) {
          setErrorMessage('La cantidad de RPU no puede ser mayor a 100');
          return;
        }
        updateMassUploadFile(csvFile);
        updateMassUploadRpuList(rpuValues);
      },
    });
  };
  const renderFile = () => {
    if (!massUploadFile) {
      return null;
    }
    return (
      <div className="request-bill-form-mass-upload-file">
        <p className="request-bill-form-mass-upload-filename">
          {massUploadFile?.name}
        </p>
        <IoMdClose
          className="request-bill-form-mass-upload-icon delete"
          onClick={() => {
            updateMassUploadFile(null);
            updateMassUploadRpuList([]);
            fileRef.current!.value = '';
          }}
        />
      </div>
    );
  };
  const renderError = () => {
    if (!errorMessage) {
      return null;
    }
    return (
      <p className="request-bill-form-mass-upload-error">{errorMessage}</p>
    );
  };

  return (
    <div className="request-bill-form-mass-upload-container">
      {renderError()}
      <div className="request-bill-form-mass-upload-button">
        <MdOutlineFileUpload className="request-bill-form-mass-upload-icon" />
        <label
          className="request-bill-form-mass-upload-text"
          htmlFor="filePicker"
        >
          Subir un archivo .csv
        </label>
        <div className="request-bill-info-helper-icon-overlay mass-upload">
          Tu archivo debe tener una columnda llamada rpu con tus números de
          servicio
        </div>
        <input
          id="filePicker"
          ref={fileRef}
          className="request-bill-form-mass-upload-input"
          type="file"
          name=""
          accept=".csv"
          onInput={changeHandler}
        />
      </div>
      {renderFile()}
    </div>
  );
};
export { MassUpload };
